export default "__VITE_ASSET__BA6FRh0b__"